/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_Exercise_PreferenceInputs */

const en_us2_offline_kind_exercise_preference = /** @type {(inputs: Offline_Kind_Exercise_PreferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercise favourite or preference`)
};

const pt_br2_offline_kind_exercise_preference = /** @type {(inputs: Offline_Kind_Exercise_PreferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favorito ou preferência de exercício`)
};

const es_419_offline_kind_exercise_preference = /** @type {(inputs: Offline_Kind_Exercise_PreferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favorito o preferencia de ejercicio`)
};

const pt_pt2_offline_kind_exercise_preference = /** @type {(inputs: Offline_Kind_Exercise_PreferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favorito ou preferência de exercício`)
};

const fr_fr2_offline_kind_exercise_preference = /** @type {(inputs: Offline_Kind_Exercise_PreferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favori ou préférence d'exercice`)
};

const de_de2_offline_kind_exercise_preference = /** @type {(inputs: Offline_Kind_Exercise_PreferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favorit oder Vorliebe für eine Übung`)
};

const it_it2_offline_kind_exercise_preference = /** @type {(inputs: Offline_Kind_Exercise_PreferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferito o preferenza di esercizio`)
};

/**
* | output |
* | --- |
* | "Exercise favourite or preference" |
*
* @param {Offline_Kind_Exercise_PreferenceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_exercise_preference = /** @type {((inputs?: Offline_Kind_Exercise_PreferenceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_Exercise_PreferenceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_exercise_preference(inputs)
	if (locale === "es-419") return es_419_offline_kind_exercise_preference(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_exercise_preference(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_exercise_preference(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_exercise_preference(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_exercise_preference(inputs)
	return en_us2_offline_kind_exercise_preference(inputs)
});
export { offline_kind_exercise_preference as "offline.kind_exercise_preference" }